import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mfs = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe":
        "Mobilize Financial Services Servicepartner in Ihrer Nähe",
      "Partnerpruefstellen in Ihrer Naehe": "Mobilize Financial Services Partner in Ihrer Nähe",
      profileHeader: {
        ...de_DE_formal.translation.profileHeader,
        "checked-by": "Mobilize Financial Services Partner",
      },
      hero: {
        title: "<strong>{{organization}}<br>Terminbuchung</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu mobilize-fs.de",
        navbar: {
          partnerLogo: {
            alt: "MFS",
          },
        },
      },
      profileDetails: {
        ...de_DE_formal.translation.profileDetails,
        "description-disclaimer": "",
      },
      booking: {
        ...de_DE_formal.translation.booking,
        hint: `Finale Terminbestätigung erfolgt durch den Mobilize Financial Services Partner. <br/>
                Bitte beachten Sie, dass die Vereinbarung des Termins verbindlich ist und nur bis spätestens 48 Stunden vor dem Termin geändert werden kann. <br />
                Bei einer Änderung, Stornierung des vereinbarten Rücknahmetermins innerhalb von 48 Stunden vor dem Termin oder bei Nichterscheinen werden wir Ihnen die dadurch entstehenden Kosten belasten.`,
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mfs",
      garageList: {
        ...de_DE_formal.translation.garageList,
        emptyState: {
          headline: "Sie haben keinen Händler in Ihrer Nähe gefunden?",
          description:
            "Die Fahrzeugrückgabe kann vertragsgemäß ausschließlich an einem Standort Ihres ausliefernden Händlers erfolgen. Eine " +
            "Rückgabe an einer DEKRA Station o.Ä. ist nicht möglich. " +
            "Bei weiteren Fragen rund um die Rückgabe Ihres Leasingfahrzeugs wenden Sie sich bitte an folgende E-Mailadresse: ",
          "bullet-point-1": "",
          "bullet-point-2": "",
        },
      },
      hotline: {
        "hotline-headline": "Mobilize Financial Services Support",
        "hotline-phone-link": "mailto:remarketing-flexilease@rcibanque.com",
        "hotline-phone": "remarketing-flexilease@rcibanque.com",
        "hotline-availability": "",
        "hotline-via-email": "",
        "hotline-via-email-email": "",
      },
      contractDetails: {
        error: {
          general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
          not_found:
            "Wir konnten anhand der Vertragsdaten keinen Vertrag finden. Bitte überprüfen Sie Ihre Vertragsdaten.",
          does_not_match:
            "Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfen Sie Vertragsnummer und Kennzeichen.",
        },
      },
    },
  },
};
